module.exports = __webpack_public_path__ + "img/600c36bfd3234202989398eaa9f55e4c-1024.eb3b7e57.jpg";